import { Box, Icon, Text } from '@medely/ui-kit';
import React from 'react';
import { JobDetailsListItem } from '../../JobDetailsListItem';
import { ShiftLocation } from '../../ShiftLocation';
import { ShiftDate } from '../../ShiftDate';
import { DisplayHelpers } from '@mp/utils';
import { AvailableGeneralInfoProps } from './interface';

export const AvailableGeneralInfo = ({
  job,
  smallIcon,
  isSaas,
  coordinates,
  isAgency,
  bookedOrInProgressOrCompleted,
}: AvailableGeneralInfoProps) => {
  return (
    <>
      <Box py={1.5}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-location-dot"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Location"
        >
          <ShiftLocation
            job={job}
            bookVariant={
              !bookedOrInProgressOrCompleted || isSaas || isAgency ? 'pre-book' : 'post-book'
            }
            distanceVariant="local"
            userCoordinates={coordinates}
          />
        </JobDetailsListItem>
      </Box>
      <Box py={1.5}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-calendar"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Date"
        >
          <ShiftDate job={job} displayStartingSoonBadge />
        </JobDetailsListItem>
      </Box>
      <Box py={1.5}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-clock"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          title="Shift time"
        >
          <Text size="m">{DisplayHelpers.job.time(job)}</Text>
        </JobDetailsListItem>
      </Box>
    </>
  );
};
